<template>
    <div class="product-item" loading="loading">
        <section class="product-item-content">
            <Tabs :animated="false" v-model="activeIndex">
                <TabPane label="拼团信息" name="0">
                    <rule
                        v-if="modelLoaded"
                        :mode="mode"
                        :setDefaultValue="setDefaultValue"
                        :setModel="setModel"
                        :model.sync="model"
                        :extra="extra" />
                </TabPane>
                <TabPane label="产品基本信息" name="1" :disabled="!modelLoaded">
                    <info
                        v-show="modelLoaded"
                        :model.sync="model"
                        :errors.sync="errors"
                        :validate="false"
                        mode="readonly"
                        :extra="extra"
                        :loaded="modelLoaded"
                        :is-tuan="mode!=='readonly'"
                        ref='info' />
                </TabPane>
                <TabPane label="购买使用说明" name="2" :disabled="!modelLoaded">
                    <instruction v-show="modelLoaded"
                                 :model.sync="model"
                                 :errors.sync="errors"
                                 :validate="false"
                                 :extra="extra"
                                 mode="readonly"
                                 :is-tuan="mode!=='readonly'"
                                 :loaded="modelLoaded"
                                 ref="instruction" />
                </TabPane>
                <TabPane label="价格/库存/有效期" name="3" :disabled="!modelLoaded">
                    <price ref="price"
                           :model.sync="model"
                           :errors.sync="errors"
                           :extra="extra"
                           mode="readonly"
                           :is-tuan="mode!=='readonly'"
                    />
                </TabPane>
            </Tabs>
        </section>
        <div class="row button-area" v-show="modelLoaded">
            <div class="col-sm-4 col-sm-offset-2">
                <Button type="primary" :disabled="onlineLoading" :loading="saveLoading" @click="save">
                    <span v-if="!saveLoading">保存</span>
                    <span v-else>保存中...</span>
                </Button>
                <Button type="primary" :disabled="saveLoading" :loading="onlineLoading" @click="saveAndOnline">
                    <span v-if="!onlineLoading">保存并上线</span>
                    <span v-else>保存中...</span>
                </Button>
            </div>
        </div>
    </div>
</template>
<script>
    import Instruction from '../item/Instruction.vue';
    import Info from '../item/Info.vue';
    import Price from '../item/Price.vue';
    import Rule from './Rule.vue';
    import { get, create, update, online, pullData } from 'api/tuanTicket';
    import getDefaultModel from '../common/defaultModel';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            Instruction,
            Info,
            Price,
            Rule
        },
        data () {
            return {
                entryTime: '',
                teHuiOption: null,
                teHuiShow: false,
                previewShowTrigger: '',
                loading: false,
                id: '',
                errors: [],
                model: {},
                activeIndex: '0',
                mode: 'edit',
                showErrorOnTabs: false,
                userinfo: false,
                modelLoaded: false,
                saveLoading: false,
                onlineLoading: false
            }
        },
        created () {
            // 组件创建完后获取数据，
            // 此时 data 已经被 observed 了
            window.router = this.$route;
            this.initProduct();
        },
        methods: {
            initProduct: async function () {
                const id = this.$route.params.id;
                this.id = id;

                const supportModes = ['new', 'edit', 'readonly'];
                if (supportModes.indexOf(this.$route.query.mode) > -1) {
                    this.mode = this.$route.query.mode;
                } else {
                    this.mode = id ? 'edit' : 'new';
                }

                if (id) {
                    this.loading = true;
                    try {
                        const json = await get(id);
                        this.model = getDefaultModel(false, false, json.data);

                    } catch (e) {
                        this.error(e.message || '数据加载失败！')
                        this.model = getDefaultModel();
                    }

                } else {
                    this.mode = 'new';
                    this.model = getDefaultModel();
                }
                this.setDefaultValue()
                this.modelLoaded = true;
            },
            setDefaultValue: function () {
                // 一些强制设置的参数，以后肯定会改，先放在这
                // 不包含保险
                this.model.containInsurance = false;
                this.model.insuranceNote = null;

                // 不可退
                this.model.refundType = 3;

                // 不可单独售卖
                this.model.sellType = 1;

                // sourceType写死成1
                this.model.sourceType = 1;

                // 美团出票
                this.model.generateTicketMethod = 1;

                //只可手动上架
                this.model.scheduleOnlineType = 3;

                if (this.mode === 'new') {
                    this.model.groupRule = {
                        relationMtDealId: 0,
                        groupNum: 2,
                        availableDays: 0,
                        availableHours: 1
                    }
                }

            },
            save: async function () {
                if(parseInt(this.model.groupRule.relationMtDealId, 10) <= 0) {
                    this.error('请先拉取关联产品');
                    return;
                }
                this.saveLoading = true;
                if (await this.saveModel()) {
                    this.$Notice.success({ title: '保存成功' });
                }
                this.saveLoading = false;
            },
            saveAndOnline: async function () {
                if(parseInt(this.model.groupRule.relationMtDealId, 10) <= 0) {
                    this.error('请先拉取关联产品');
                    return;
                }
                this.onlineLoading = true;
                try {
                    if (await this.saveModel()) {
                        await online(this.id);
                        this.$Notice.success({ title: '保存并上线成功' });
                    }
                } catch (e) {
                    this.$Notice.error({ title: '上线失败', desc: e.message || '上线失败, 网络错误'});
                }
                this.onlineLoading = false;
            },
            saveModel: async function () {
                try {
                    if (this.mode === 'new') {
                        const id =  (await create(this.prepareData(this.model))).data.dealId;
                        if (id) {
                            this.id = id;
                            this.mode = 'edit';
                            let state = this.$router.resolve({name: this.$route.name, query: { mode:'edit', supplierId:this.extra.supplierId}, params: {id: id}});
                            history.pushState(null, 'notp', state.href);
                            return true;
                        }
                        throw new Error('接口错误，请稍后重试')
                    } else {
                        await update(this.prepareData(this.model), this.id);
                        return true;
                    }
                } catch (e) {
                    this.$Notice.error({ title: '保存失败', desc: e.message || '保存失败, 网络错误'});
                    return false;
                }
            },
            setModel: async function (id, contractNum) {
                let json;
                try {
                    json = await pullData(id, contractNum);
                } catch (e) {
                    this.$Notice.error({ title: '拉取失败', desc: e.message || '网络错误'});
                    return false;
                }
                this.model = getDefaultModel(false, false, json.data);
                this.setDefaultValue();
                this.model.contractNum = this.extra.contractNum;
                this.model.contractId = this.extra.contractId;
                this.model.groupRule.relationMtDealId = id;
                await this.$refs.info.updateModel();
                this.$refs.instruction.updateModel();
                return true;
            },
            error: function (message) {
                this.$Message.error({
                    content: message,
                    duration: 5
                });
            },
            prepareData(model) {
                let data = JSON.parse(JSON.stringify(model))
                if (parseInt(data.scheduleOfflineType, 10) === 1) {
                    data.scheduleOfflineTime = null;
                }
                if (!data.includeItems || (data.includeItems && data.includeItems.length <= 1)) {
                    data.isAllAvailable = undefined;
                    data.availableCount = undefined;
                }
                if (data.useDateMode == 1 && data.stockType === 1) {
                    data.dayPriceStockRules.forEach((item) => {
                        item.stock = -1;
                    });
                }
                for (let crowd of data.ticketPoiDiscounts) {
                    if (!crowd.ticketDiscountList || (crowd.ticketDiscountList.length === 1 && crowd.ticketDiscountList[0].crowd === null)) {
                        crowd.ticketDiscountList = null
                    }
                }
                //有效期模式，不限库存，stock设为-1
                if (parseInt(data.stockType, 10) === 1 && parseInt(data.useDateMode, 10) === 0) {
                    data.stock = -1;
                }
                // 处理换票凭证和入园凭证，只能出现1和6
                data.getTicketRule.voucherLoaders = [];
                data.getVoucherRule.voucherLoaders = [];
                if (model.needTicket) {
                    this.model.getTicketRule.voucherLoaders.indexOf(1)>-1?data.getTicketRule.voucherLoaders.push(1):'';
                    this.model.getTicketRule.voucherLoaders.indexOf(6)>-1?data.getTicketRule.voucherLoaders.push(6):'';
                } else {
                    this.model.getVoucherRule.voucherLoaders.indexOf(1)>-1?data.getVoucherRule.voucherLoaders.push(1):'';
                    this.model.getVoucherRule.voucherLoaders.indexOf(6)>-1?data.getVoucherRule.voucherLoaders.push(6):'';
                }

                return data;
            }
        },
        computed: {
            ...mapGetters(['account']),
            // 获取其他非deal的信息
            extra () {
                const DirectDealIDs = [
                    2, // 直连V2
                    4, // 直连V1
                    5, // 手工上单转直连
                ]
                return {
                    partnerDealId: this.model.partnerDealId,
                    // 是否是直签商家， true是，false为三方
                    isDirect: false,
                    // 是否直连产品
                    isDirectDeal: false,
                    // 是否是bd上单模板
                    isBD: true,
                    contractNum: this.$route.query.contractNum || this.model.contractNum,
                    contractId: this.$route.query.contractId || this.model.contractId,
                    supplierId: this.$route.query.supplierId || this.account.supplierId,
                    isNew: (!this.id || this.mode === 'copy') && !this.model.mtDealId
                };
            }
        },
    }
</script>
<style rel="stylesheet/css" lang="postcss" type="text/postcss">
    input[type=checkbox]:checked:after {
        box-sizing: content-box;
    }
</style>


// WEBPACK FOOTER //
// Main.vue?f6771242